import ISlideMaster from '@app/types/presentations/master/ISlideMaster';
import IPresentationSettings from '@app/types/presentations/presentation/IPresentationSettings';
import ICooperationSlideData from '../../types/data/slides/ICooperationSlideData';
import AbstractSlideTransform from './AbstractSlideTransform';

/**
 * Transform for 002-WelcomeSlide
 */
export default class CooperationSlideTransform extends AbstractSlideTransform {
	public viewComponent: string = 'CooperationSlide';

	public async transform(
		slide: ISlideMaster,
		presentationSettings: IPresentationSettings
	): Promise<ICooperationSlideData> {
		const data: ICooperationSlideData = {
			id: slide.id,
			label: slide.fields.label || slide.fields.headline,
			shareViewSection: slide.fields.shareViewSection === 'special-info' ? 'special-info' : undefined,
			thumbnail: this.extractThumbnail(slide.fields.headline, slide, 'image'),
			image: this.transformImageAsset(slide.fields.image?.fields.asset ?? this.getFallbackImage(), {
				width: 5000,
				height: 5000,
				crop: 'limit'
			}),
			headline: slide.fields.headline,
			subline: slide.fields.subline,
			copy: this.transformRichtext(slide.fields.copy, presentationSettings),
			badgeText: slide.fields.badgeText
		};

		if (slide.fields.affiliateLogo && slide.fields.affiliateLogo.fields.asset) {
			data.affiliateLogo = this.transformImageAsset(slide.fields.affiliateLogo.fields.asset, {
				width: 1000,
				height: 1000,
				crop: 'limit',
				fetchFormat: 'png'
			});
		}

		return data;
	}
}
